<template>
  <!--冰箱服务协议界面内容 -->
  <div style="width:100%;height:calc(100vh - 50px);overflow: hidden;" ref="fridgefragment">
    <div>
      <hint></hint>
      <question-list :Datalist="datalist" @scrollto="ScrollTo" :scroll="scroll"></question-list>
      <div class="struction_style" id='struction' v-html="struction">
      </div>
      <fridge-charge></fridge-charge>
    </div>
  </div>
</template>

<script>
import hint from './hint.vue'
import QuestionList from './questionList.vue'
import { fridgeinstruction } from '../struction/fridge'
import FridgeCharge from './FridgeCharge.vue'
import BScroll from '@better-scroll/core'
export default {
  name: "Fridge",
  data() {
    return {
      screenHeight: '500px',
      datalist: [
        { des: '·冰箱（柜）、洗衣机“三包”及主要部件', ref: 'fridgeinstruction', href: '#fridgeinstruction' },
        { des: '·不属于“三包”范围的情况说明', ref: 'outfridgerange', href: '#outfridgerange' },
        { des: '·冰箱/柜服务收费标准', ref: 'fridgstandard', href: '#fridgstandard' }
        //                {des:'·洗衣机服务收费标准',ref:'washerservice',href:'#washerservice'}
      ],
      struction: fridgeinstruction.fridgeTitle + fridgeinstruction.fridgeContent,
      scroll: '',
    }
  },
  props: {
    active: {
      type: String,
      default: '',
    }
  },
  mounted() {
    this.screenHeight = (window.innerHeight - 320) + "px";
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.fridgefragment, {
        click: true,
        scrollY: true,
        bounce: true,
      });
      this.scroll.refresh();
    }); 
  },
  methods: {
    ScrollTo: function (ref) {
      var updistance = document.getElementById("struction").offsetTop;
      var distance = document.getElementById(ref).offsetTop;
      var scrolldis = document.getElementById('struction').scrollTop = distance - updistance - 10;
    }
  },
  components: {
    'hint': hint,
    'question-list': QuestionList,
    'fridge-charge': FridgeCharge
  },
  watch: {
    active(newValue, oldValue) {
      if(newValue === "fridge_container"){
        this.scroll.refresh();
      }
    }
  }
}
</script>

<style scoped>
  .struction_style{
    width:92%;
    display: inline-block;
    text-align: left;
    /* padding-left: 4%; */
    line-height: 120%;
    
    background: #FAFAFA;
  }
  .inner {
    height: calc(100% + 1px);
  }
</style>



// WEBPACK FOOTER //
// src/components/Fridge.vue